import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch, ILazyParams, baseUrl } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Table } from "../showTimesheet/Table";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { Panel } from "primereact/panel";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { format } from "date-fns";
import { GenerateInvoices, IInvoiceTracking } from "./Form";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
// import { Form } from "./GenerateInvoice";
import { MultiInvoiceStatusUpdate } from "./MultiInvoiceStatusUpdate";
import { JVInput } from "../../shared/JVInput";
import { InvoiceRemitance } from "./InvoiceRemitance";
import { SubVendorInvoices } from "../subVendorInvoices";
import { GenerateInvice } from "../subVendorInvoices/GenerateInvice";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { History } from "./History";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface InvoiceTracking {
    addedBy?: string,
    client?: string,
    consultant_ID?: number,
    consultant_Name?: string,
    dueDate?: string,
    end_Client?: string,
    fromDate?: string,
    invoiceAmount?: number,
    invoiceHours?: number,
    invoiceNo?: string,
    invoicePath?: string,
    invoice_ID?: number,
    job_Titles?: string,
    mRate?: number,
    pO_ID?: number,
    prime_Vendor_Billing_Cycle?: string,
    prime_Vendor_Payment_Term?: string,
    sRate?: number,
    sales?: string,
    start_Date?: string,
    timeSheet_Status1?: string,
    toDate?: string,
    vendor?: string,
    verfiedBy?: number,
    verifiedBy?: string,
    invoiceStatus?: string,
    createdOn?: string,
    verifyComment?: string,
    paymentStatus?: string,
    balance_Rate?: number,
    receivedAmount?: number,
    payment_Mode?: string,
    transaction_ID?: string,
    isInoviceRemitance?: boolean,
    aging?: number,
    credit_Note_Comment?: string,
    releasePaymentDate?: Date,
    releasePaymentType?: number,
    isCalculated?: boolean,
    invoiceDate?: Date,
    payment_Date?: Date,
    is_Credit_Note?: boolean
};



interface IProps {
    permissions: IPermissionProps,
    toast: any,
    po: IPurchaseOrder,
}

export const EmptyFilter: InvoiceTrackingFilter = {
    year: null,
    month: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    paymentStatus: null,
    dueDateFrom: null,
    dueDateTo: null,
    invoiceNO: "",
    consultant: {
        consultant_ID: 0,
        consultant_Name: ""
    },
}


export const InvoiceTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: InvoiceTracking[], loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [consultantAllInvoices, setConsultantAllInvoices] = useState({ singleData: 0, open: false } as { singleData: number, open: boolean });
    const [generateInvoices, setGenerateInvoices] = useState({ singleData: {}, open: false, action: false } as { singleData: IInvoiceTracking, open: boolean, action: boolean });
    const [selectedBenchs, setSelectedBenchs] = useState<any>();
    const [selectedHotList, setSelectedHotList] = useState<Array<number | undefined>>();
    const [openHotList, setOpenHotList] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openRemitance, setOpenRemitance] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });
    const [openSubvendorModal, setOpenSubvendorModal] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [showMultisec, setShowMultisec] = useState<boolean>(false);
    const [isCreditNoteOpen, setIsCreditNoteOpen] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [credit_Note_Comment, setCredit_Note_Comment] = useState("");
    const [openHistory, setOpenHistory] = useState({ singleData: {}, open: false } as { singleData: InvoiceTracking, open: boolean });

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 100,
        page: 1,
        sortField: 'invoice_ID',
        sortOrder: -1
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });




    const consultant_Name = (rowData: InvoiceTracking) => {
        return (
            <>
                <span className={"cursor-pointer underline " + (rowData.paymentStatus === "Pending" ? "text-white" : "text-cyan-700")}>{rowData?.consultant_Name}</span>
            </>
        );
    };

    const onHideCreditNote = () => {
        setIsCreditNoteOpen({ singleData: {}, open: false });
        setCredit_Note_Comment("");
    }

    const credit_Note = (rowData: InvoiceTracking) => {
        const isCredit: boolean = rowData.receivedAmount !== null ? Number(rowData.invoiceAmount) > Number(rowData.receivedAmount) : false;
        return (
            <>
                <span className={(!isCredit ? (rowData.paymentStatus === "Pending" ? "text-white" : "text-black") : "cursor-pointer underline text-cyan-700")} onClick={() => setIsCreditNoteOpen(prev => prev = { singleData: rowData, open: true })}>{!isCredit ? "" : "Credit Note"}</span>
            </>
        );
    };

    useEffect(() => {
        if (isCreditNoteOpen.open) {
            if (isCreditNoteOpen.singleData.credit_Note_Comment != null && isCreditNoteOpen.singleData.credit_Note_Comment.trim() != "") setCredit_Note_Comment(isCreditNoteOpen.singleData.credit_Note_Comment);
        };
    }, [isCreditNoteOpen.open]);

    const getSubvendorInvoiceDetails = async (data: InvoiceTracking) => {
        const response = await Fetch('InvoiceTracking/getSubvendorDetailsByPOID', 'GET', null, `poID=${data.pO_ID}`, null);
        if (response) {
            const respdata: any = await response.json();
            // console.log("---- respdata ----", respdata);
            let svInvoiceData: any = {
                bRate: respdata.bRate,
                consultant_ID: data.consultant_ID,
                consultant_Name: data.consultant_Name,
                dueDate: null,
                fromDate: new Date(data?.fromDate || ""),
                invoiceAmount: null,
                invoiceDate: null,
                invoiceNO: null,
                invoicePath: null,
                pO_ID: data.pO_ID,
                paidAmount: null,
                paymentStatus: null,
                payment_Date: null,
                payment_Mode: null,
                primeVendor_Company_Name: respdata.vendor_Company_Name,
                primevendorInvoice_ID: data.invoice_ID,
                requestedAmount: null,
                toDate: new Date(data?.toDate || ""),
                transaction_ID: null,
                workingHours: data.invoiceHours,
                vendor_Company_ID: respdata.sub_Vendor_ID,
                vendor_Company_Name: respdata.sub_Vendor_Company,
                sub_Vendor_Payment_Term: respdata.sub_Vendor_Payment_Term,
                sub_Vendor_Billing_Cycle: respdata.sub_Vendor_Billing_Cycle,
                project_Start_Date: new Date(respdata.project_Start_Date),
                project_End_Date: new Date(respdata.project_End_Date),
                prime_Vendor_Billing_Cycle: respdata.prime_Vendor_Billing_Cycle,
            };
            // console.log("---- svInvoiceData ----", svInvoiceData);
            setOpenSubvendorModal({ singleData: svInvoiceData, open: true });
        }
    }

    const reCalculateInvoice = (rowData: InvoiceTracking) => {
        confirmDialog({
            message: `Are you sure you want to re-calculate incentive amount"?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => reCalculateIncetiveAmount(rowData),
            reject: () => rejectFunc()
        });
    }

    const deleteInvoice = (rowData: InvoiceTracking) => {
        confirmDialog({
            message: `Are you sure you want this Invoice"?`,
            // header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-success',
            accept: () => deleteInvoiceEndPoint(rowData),
            reject: () => rejectFunc()
        });
    }

    const reCalculateIncetiveAmount = async (rowData: InvoiceTracking) => {
        if (rowData.isCalculated === true) {
            props.toast.current.show({ severity: 'error', detail: "Incentive Calculation Is Hold", life: 3000 });
        } else {
            const response = await Fetch("InvoiceTracking/reCalculateIncetiveAmount", "PUT", null, `invoice_ID=${rowData.invoice_ID}`, props.toast);
            if (response) {
                props.toast.current.show({ severity: 'success', detail: "Re-Calculated Successfully", life: 3000 });
                loadTableData();
            }
        }
    }

    const deleteInvoiceEndPoint = async (rowData: InvoiceTracking) => {
        const response = await Fetch("InvoiceTracking/deleteInvoiceByID", "DELETE", null, `invoice_ID=${rowData.invoice_ID}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Invoice Deleted Successfully", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => {
        // dialog closed.
    }


    const action = (rowData: InvoiceTracking) => {
        let data = {
            invoice_ID: rowData.invoice_ID,
            paymentStatus: rowData.paymentStatus,
            receivedAmount: rowData.receivedAmount,
            payment_Mode: rowData.payment_Mode,
            transaction_ID: rowData.transaction_ID,
            invoiceAmount: rowData.invoiceAmount,
            releasePaymentType: rowData.releasePaymentType,
            isCalculated: rowData.isCalculated,
            payment_Date: rowData.payment_Date,
            is_Credit_Note: rowData.is_Credit_Note
        };

        return <div style={{ width: "8rem", display: "flex", justifyContent: "space-between", gap: "3px" }}>
            {rowData.invoice_ID ? <React.Fragment>
                {(_roles.includes(1) || (_roles.includes(42) || _roles.includes(38))) && <Button className={(rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? "pi pi-pencil text-primary bg-green-300 border-none text-base" : "pi pi-pencil text-primary bg-white border-none text-base"} tooltip="Edit" onClick={() => setGenerateInvoices({ singleData: { ...data, verify: (rowData.verifiedBy && rowData.verifiedBy !== null && rowData.verifiedBy !== "") ? true : false }, open: true, action: false })}></Button>}
            </React.Fragment> : ''}
            {(_roles.includes(43) || _roles.includes(1) || _roles.includes(38)) && <Button className={"pi pi-sitemap border-none"} tooltip="Subvendor Inovice" onClick={() => getSubvendorInvoiceDetails(rowData)}></Button>}
            {(_roles.includes(42) || _roles.includes(1) || _roles.includes(38)) && <Button className={"pi pi-replay border-none"} tooltip="Re-Calculate Inovice" onClick={() => reCalculateInvoice(rowData)}></Button>}
            {(_roles.includes(42) || _roles.includes(1) || _roles.includes(38)) && <Button className={"pi pi-trash border-none"} tooltip="Delete Inovice" onClick={() => deleteInvoice(rowData)}></Button>}
        </div>;
    };


    const hideDialog = () => {
        setGenerateInvoices({ singleData: {}, open: false, action: false });
        setSelectedHotList([]);
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        if (invoiceFilter.vendor_Company !== null && invoiceFilter.vendor_Company !== undefined && invoiceFilter.vendor_Company?.vendor_Company_ID !== undefined && invoiceFilter.vendor_Company?.vendor_Company_ID !== 0) {
            setShowMultisec(prev => prev = true);
        } else {
            setShowMultisec(prev => prev = false);
        }

        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;
        updateInvoiceFilter.consultantName = invoiceFilter.consultant?.consultant_Name;

        delete updateInvoiceFilter.consultant;

        let po_id_Query = "";

        const response = await Fetch("InvoiceTracking/getallinvoices", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setTableData({ tableData: data, loading: false });
            //setTotalRecords(2614);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }
    const loadTableDataCount = async () => {
        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;

        let po_id_Query = "";


        const response = await Fetch("InvoiceTracking/getInvoicesCount", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + `&Consultant_ID=${consultantAllInvoices.singleData}` + po_id_Query, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    };
    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const newInv = (rowData: InvoiceTracking) => {
        let newdata = {
            pO_ID: rowData.pO_ID,
            consultant_ID: rowData.consultant_ID,
            invoiceRate: rowData.mRate,
            invoice_Cycle: rowData.prime_Vendor_Billing_Cycle,
            payment_Term: rowData.prime_Vendor_Payment_Term
        };
    };

    // const rowClass = (data: any) => {
    //     return {
    //         'bg-green-300 text-black': (data.verifiedBy && data.verifiedBy !== null && data.verifiedBy !== ""),
    //         //'bg-yellow-100 text-black': data.verifiedBy === null,
    //         'bg-pink-100 text-black': data.verifiedBy === null,
    //     };
    // };

    const downLoadInvoice = async (rowData: InvoiceTracking) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"InvoiceTracking/download"}?path=${rowData.invoicePath}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData?.invoiceNo}.pdf`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onSave = async () => {
        if (credit_Note_Comment === null || credit_Note_Comment.trim() === "") {
            props.toast.current.show({ severity: 'warn', detail: 'Please enter a reason for credit note.', life: 3000 });
        } else {
            const data = {
                invoice_ID: isCreditNoteOpen.singleData.invoice_ID,
                credit_Note_Comment: credit_Note_Comment
            };
            const response = await Fetch("InvoiceTracking/updateCreditNote", "PUT", data, null, props.toast);
            if (response) {
                setCredit_Note_Comment("");
                setIsCreditNoteOpen({ singleData: {}, open: false });
                loadTableData();
                loadTableDataCount();
            }
        }
    };

    useEffect(() => {
        //setConsultantAllInvoices({ singleData: 0, open: false });
        loadTableData();
        loadTableDataCount();
    }, [lazyParams, invoiceFilter, consultantAllInvoices]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };


    const rightToolbarTemplate = () => {
        return (
            <>
                <Button
                    label="Bulk Update Payment Status"
                    onClick={() => {
                        if (selectedBenchs && selectedBenchs.length > 1) {
                            setOpenHotList(true); // Open bulk update modal
                        } else {
                            props.toast.current.show({
                                severity: 'warn',
                                detail: 'Please select at least 2 invoices to update multiple invoice.',
                                life: 3000,
                            });
                        }
                    }}
                />
                <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
            </>
        );
    };

    const onHideMultipleInvoiceUpdateForm = () => {
        setOpenHotList(false);
        loadTableData();
        loadTableDataCount();
        setOpenHotList(false);
        setSelectedBenchs([]);
    };

    const onHideRemitanceModal = () => {
        setOpenRemitance({ singleData: {}, open: false });
        setOpenHotList(false);
        setSelectedBenchs([]);
    };

    const onHideSubvendorInv = () => {
        setOpenSubvendorModal({ singleData: {}, open: false });
    };

    const onCloseOpenHistory = () => {
        setOpenHistory({ singleData: {}, open: false });
    }

    const rowClass = (data: any) => {
        return {
            'bg-green-300 text-black': data.paymentStatus === "Paid",
            'bg-blue-200 text-black': data.paymentStatus === "Balance",
            'bg-red-400 text-white': data.paymentStatus === "Pending",
            'bg-orange-300 text-black': data.paymentStatus === "Over Payment",
        };
    }

    const DateFormat = loginObj.date_Format
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            {/* <Toolbar className="mb-1 py-0"  ></Toolbar> */}
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={props.po.pO_ID ? true : false} fromHierarchyList={false} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt}
                size="small" stripedRows showGridlines responsiveLayout="scroll"
                value={tableData.tableData}
                loading={tableData.loading}
                selection={selectedBenchs}
                totalRecords={totalRecords}
                onSelectionChange={(e) => {
                    if (e.value.verfiedBy === null || _roles.includes(1)) {
                        setSelectedBenchs(e.value);
                    }
                }}
                selectionMode="multiple"
                dataKey="invoice_ID"
                lazy
                paginator
                rows={100}
                rowsPerPageOptions={[100]}
                rowClassName={rowClass}
                first={lazyParams.first}
                onPage={onPage}
                emptyMessage="No Invoice found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            >
                {showMultisec === true && <Column selectionMode="multiple" />}
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Name" body={consultant_Name} />
                <Column field="prime_Vendor_Company" header="Prime Vendor Company" />
                <Column field="invoiceNO" header="Invoice#" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} /> */}
                <Column field="fromDate" header="From Date" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.fromDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="toDate" header="To Date" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.toDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="invoiceStatus" header="Inv Status" />
                <Column field="invoiceHours" header="Hours" />
                <Column field="sRate" header="Rate" />
                <Column field="invoiceAmount" header="Amout" />
                {/* <Column field="dueDate" header="Due Date" body={dueDate} /> */}
                <Column field="dueDate" header="Due Date" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.dueDate, "dd/MM/yyyy", DateFormat)} />
                {/* <Column field="createdOn" header="Created On" body={(rowData: InvoiceTracking) => {
                    let date;
                    if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} /> */}
                 <Column field="createdOn" header="Created On" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.createdOn, "dd/MM/yyyy", DateFormat)}  />
                {/* <Column field="invoiceDate" header="Invoice Date" body={(rowData: InvoiceTracking) => {
                    let date;
                    if (rowData.invoiceDate) date = format(new Date(rowData.invoiceDate), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} /> */}
                <Column field="invoiceDate" header="Invoice Date" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.invoiceDate, "dd/MM/yyyy", DateFormat)} />
                <Column field="paymentStatus" header="Payment Status" body={(rowData: InvoiceTracking) => <p className={rowData.isInoviceRemitance === true ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => {
                    if (rowData.isInoviceRemitance === true) {
                        setOpenRemitance({ singleData: rowData, open: true });
                    }
                }} >{rowData.paymentStatus}</p>} />
                {/* <Column field="payment_Date" header="Payment Date" body={(rowData: InvoiceTracking) => {
                    let date;
                    if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} /> */}
                <Column field="payment_Date" header="Payment Date" style={{minWidth: "10rem"}} body={(rowData: any) => safeFormatDate(rowData.payment_Date,'dd/MM/yyyy', DateFormat )} />
                <Column field="receivedAmount" header="Received Amount" />
                <Column field="payment_Mode" header="Payment Mode" />
                <Column field="transaction_ID" header="Transaction ID" />
                <Column field="aging" header="Aging" />
                <Column header="Credit Note" body={credit_Note} />
                {((_roles.includes(1) || _roles.includes(33) || _roles.includes(42) || _roles.includes(43) || _roles.includes(38))) && <Column header="Action" style={{minWidth: "10rem"}} body={action} />}
                <Column header="History" body={(rowData) => <Button icon="pi pi-history" onClick={() => setOpenHistory({ singleData: rowData, open: true })} />} />
            </DataTable>
            <GenerateInvoices open={generateInvoices.open} toast={props.toast} hideDialog={hideDialog} singleData={generateInvoices.singleData} action={generateInvoices.action} loadTableData={loadTableData} loadTableDataCount={loadTableDataCount} po={props.po} />
            {/* <Form singleData={selectedHotList} open={openHotList} hideDialog={hideDialog} toast={props.toast} setSelectedBenchs={setSelectedBenchs} /> */}
            <Dialog style={{ width: '70vw' }} visible={openHotList} onHide={() => setOpenHotList(false)} header="Bulk Update Payment Status" >
                {/* <form onSubmit={handleSubmit(onSubmitBulk)} className="p-fluid formgrid grid" >
                    <div className='field col-12 md:col-4'>
                        <label>Total Invoice Amount</label>
                        <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>21312321321313</p>
                    </div>
                    <JVInput required column={2} label="State Name" control={control} name="state_Name"
                    //error={errors.state_Name?.message} 
                    />
                    <JVDropdown column={2} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} />
                    <Button label="Update" type="submit" loading={loading} />
                </form> */}
                <MultiInvoiceStatusUpdate tableData={selectedBenchs} open={openHotList} hideDialoge={() => onHideMultipleInvoiceUpdateForm()} toast={props.toast} />
            </Dialog>

            <Dialog style={{ width: '70vw' }} visible={openSubvendorModal.open} onHide={() => onHideSubvendorInv()} header="Subvendor Invoice" >
                <GenerateInvice singleData={openSubvendorModal.singleData} toast={props.toast} onHideSubvendorInv={onHideSubvendorInv} />
                {/* <SubVendorInvoices byPrimeInvoice={openSubvendorModal} /> */}
            </Dialog >

            <Dialog style={{ width: '70vw' }} visible={openRemitance.open} onHide={() => onHideRemitanceModal()} header="Invoice Remitance" >
                <InvoiceRemitance open={openRemitance.open} singleData={openRemitance.singleData} onHide={() => onHideRemitanceModal()} toast={props.toast} />
            </Dialog >

            <Dialog style={{ width: '70vw' }} visible={isCreditNoteOpen.open} onHide={() => onHideCreditNote()} header="Credit Note">
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <label htmlFor="reason">Credit Note Reason<span style={{ color: 'red' }}>*</span> </label>
                    <InputTextarea name="credit_Note_Comment" placeholder="Write Credit Note reason" value={credit_Note_Comment} onChange={(e) => setCredit_Note_Comment(e.target.value)} rows={5} cols={120} maxLength={300} autoResize />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" onClick={onSave}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={() => onHideCreditNote()} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </Dialog>
            <History open={openHistory.open} singleData={openHistory.singleData} onHide={onCloseOpenHistory} toast={props.toast} />
            <ConfirmDialog />

        </>
    );
}